import Section from '../Section';

export default class Password extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$head = document.querySelector('.site-header');
    if (!this.$head) return;
    this.$focusableEls = this.$head.querySelectorAll('a[href], input:not([disabled]):not([type="hidden"]), button:not([disabled]), [tabindex="0"]');
    this.$password = this.$head.querySelector('input#password');
    this.firstFocusableEl = /** @type {HTMLElement} */ (this.$focusableEls[0]);
    this.lastFocusableEl = /** @type {HTMLElement} */ (this.$focusableEls[this.$focusableEls.length - 1]);

    this.load();
  }

  load = () => {
    var self = this;

    const passwordShowEl = document.querySelector('.password-show');
    if (passwordShowEl) {
      passwordShowEl.addEventListener('click', function() {
        self.$head.classList.toggle('open');
        self.$head.style.display = self.$head.style.display === 'none' ? 'block' : 'none';
        document.querySelector('.password--container').classList.add('password-modal--open');
        self.$password.focus();
      });
    }

    const passwordCloseEl = document.querySelector('.password--close');
    if (passwordCloseEl) {
      passwordCloseEl.addEventListener('click', function() {
        self.$head.classList.toggle('open');
        self.$head.style.display = self.$head.style.display === 'none' ? 'block' : 'none';
        document.querySelector('.password--container').classList.remove('password-modal--open');
        self.$password.blur();
      });
    }

    if (document.querySelector('.storefront-password-form .errors')) {
      self.$head.style.display = 'block';
      self.$head.classList.add('open');
      self.$password.focus();
    }

    // Detect click outside of popup to close it.
    const passwordWrapperEl = document.querySelector('.password--wrapper');
    if (passwordWrapperEl) {
      passwordWrapperEl.addEventListener('click', e => {
        if (self.$head.classList.contains('open')) {
          if (!self.$head.contains(e.target) && !document.querySelector('.password-show').contains(e.target)) {
            self.$head.style.display = 'none';
          }
        }
      });
    }

    // Keep tabbing within the modal while it is open.
    document.addEventListener('keydown', function(e) {
      e = e || window.event;

      if (e.key === 'Tab') {
        // Keep tab within the open modal.
        if (e.shiftKey) {
          if (document.activeElement === self.firstFocusableEl) {
            e.preventDefault();
            self.lastFocusableEl.focus();
          }
        } else {
          if (document.activeElement === self.lastFocusableEl) {
            e.preventDefault();
            self.firstFocusableEl.focus();
          }
        }
      } else if (e.key === 'Escape') {
        // Escape to close popup.
        if (self.$head.classList.contains('open')) {
          self.$head.classList.toggle('open');
          self.$head.style.display = 'none';
          self.$password.blur();
        }
      }
    });
  }
}
